module.exports = __webpack_public_path__ + "static/media/resolva-logo.039256e5.svg";